import { useHistory, useLocation } from "react-router-dom";

export const useTabNavigation = () => {
  const history = useHistory();
  const location = useLocation();

  const handleTabChange = (tabKey) => {
    const currentParams = new URLSearchParams(location.search);
    const currentTab = currentParams.get("tab");
    if (currentTab === tabKey) {
      return; // No need to update if the selected tab is already active
    }
    currentParams.set("tab", tabKey);
    const newUrl = `${location.pathname}?${currentParams.toString()}`;
    history.push(newUrl);
  };

  return handleTabChange;
};
